import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { t } from '../../services/i18nService';
import styles from './tableOfContents.scss';
import questionSelectionService from '../../services/QuestionSelectionService';
import settingsReader from '../../store/readHelpers/SettingsReader';
import tocActions from '../../actions/TocActions';
import Filter from './TOCFilterItem';

const { filterTypes } = tocActions;

class TOCFilters extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        dispatch: PropTypes.func.isRequired,
        settings: PropTypes.object,
        toc: PropTypes.object,
    };

    render() {
        const { settings, dispatch, toc, className } = this.props;
        const questionSelectionEnabled = questionSelectionService.atLeastOneSectionWithQuestionSelectionEnabled();
        const flaggingEnabled = settingsReader.isFlaggingEnabled(settings);

        const classList = [styles.filters];
        if (className) {
            classList.push(className);
        }

        return (
            <div className={classList.join(' ')}>
                <h3 className="sr-only">{t('testOverview.filterQuestionsHeader')}</h3>
                <div className="overview-filters" role="tablist" aria-label={t('testOverview.questionFIlters')}>
                    <Filter
                        id="tab-all"
                        ariaControl="tabpanel-all"
                        ariaSelected={filterTypes.ALL === toc.filter}
                        filterName={filterTypes.ALL}
                        dispatch={dispatch}
                    />
                    {!questionSelectionEnabled ?
                        <Filter
                            id="tab-not-attempted"
                            ariaControl="tabpanel-not-attempted"
                            ariaSelected={filterTypes.NOT_ATTEMPTED === toc.filter}
                            filterName={filterTypes.NOT_ATTEMPTED}
                            dispatch={dispatch}
                        />
                        :
                        null
                    }
                    {questionSelectionEnabled ?
                        <Filter
                            id="tab-manually-selected"
                            ariaControl="tabpanel-manually-selected"
                            ariaSelected={filterTypes.MANUALLY_SELECTED === toc.filter}
                            filterName={filterTypes.MANUALLY_SELECTED}
                            dispatch={dispatch}
                        />
                        :
                        null
                    }
                    {questionSelectionEnabled ?
                        <Filter
                            id="tab-manually-selected-not-attempted"
                            ariaControl="tabpanel-manually-selected-not-attempted"
                            ariaSelected={filterTypes.MANUALLY_SELECTED_NOT_ATTEMPTED === toc.filter}
                            filterName={filterTypes.MANUALLY_SELECTED_NOT_ATTEMPTED}
                            dispatch={dispatch}
                        />
                        :
                        null
                    }
                    {flaggingEnabled && !questionSelectionEnabled ?
                        <Filter
                            id="tab-flagged"
                            ariaControl="tabpanel-flagged"
                            ariaSelected={filterTypes.FLAGGED === toc.filter}
                            filterName={filterTypes.FLAGGED}
                            dispatch={dispatch}
                        />
                        : null
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { toc } = state;
    return { toc };
}

const TOCFiltersContainer = connect(mapStateToProps)(TOCFilters);

export default TOCFiltersContainer;
